// Financial Skills organized by subcategories
export const FINANCIAL_SKILLS_CATEGORIES = [
  {
    name: 'Accounting',
    skills: [
      'Financial Accounting', 'Management Accounting', 'Cost Accounting',
      'Tax Accounting', 'Audit Preparation', 'Bookkeeping',
      'Account Reconciliation', 'Financial Statements', 'General Ledger',
      'Accounts Payable', 'Accounts Receivable', 'Fixed Assets',
      'Payroll Processing', 'Accounting Standards', 'Accounting Software'
    ]
  },
  {
    name: 'Financial Analysis',
    skills: [
      'Financial Modeling', 'Ratio Analysis', 'Trend Analysis',
      'Variance Analysis', 'Cost Analysis', 'Budget Analysis',
      'Investment Analysis', 'Risk Analysis', 'Performance Analysis',
      'Profitability Analysis', 'Cash Flow Analysis', 'Credit Analysis',
      'Financial Forecasting', 'Financial Planning', 'Financial Strategy'
    ]
  },
  {
    name: 'Investment Management',
    skills: [
      'Portfolio Management', 'Asset Allocation', 'Investment Strategy',
      'Risk Management', 'Market Analysis', 'Securities Analysis',
      'Fund Management', 'Wealth Management', 'Investment Research',
      'Performance Monitoring', 'Investment Planning', 'Investment Tools',
      'Investment Products', 'Investment Operations', 'Investment Compliance'
    ]
  },
  {
    name: 'Corporate Finance',
    skills: [
      'Financial Planning', 'Capital Budgeting', 'Working Capital Management',
      'Corporate Strategy', 'Mergers & Acquisitions', 'Financial Restructuring',
      'Treasury Management', 'Risk Management', 'Financial Control',
      'Business Valuation', 'Financial Reporting', 'Corporate Governance',
      'Stakeholder Management', 'Financial Policy', 'Financial Operations'
    ]
  },
  {
    name: 'Banking Operations',
    skills: [
      'Retail Banking', 'Commercial Banking', 'Investment Banking',
      'Credit Management', 'Loan Processing', 'Banking Products',
      'Banking Services', 'Banking Compliance', 'Banking Operations',
      'Banking Software', 'Customer Service', 'Risk Assessment',
      'Transaction Processing', 'Account Management', 'Banking Standards'
    ]
  },
  {
    name: 'Risk Management',
    skills: [
      'Risk Assessment', 'Risk Mitigation', 'Risk Monitoring',
      'Compliance Management', 'Internal Controls', 'Audit Management',
      'Risk Reporting', 'Risk Strategy', 'Risk Analysis',
      'Risk Tools', 'Risk Standards', 'Risk Documentation',
      'Risk Communication', 'Risk Planning', 'Risk Operations'
    ]
  },
  {
    name: 'Financial Markets',
    skills: [
      'Market Analysis', 'Trading Strategy', 'Market Research',
      'Technical Analysis', 'Fundamental Analysis', 'Market Operations',
      'Market Risk', 'Market Compliance', 'Market Tools',
      'Market Data', 'Market Intelligence', 'Market Reporting',
      'Market Development', 'Market Planning', 'Market Management'
    ]
  },
  {
    name: 'Insurance',
    skills: [
      'Risk Assessment', 'Policy Management', 'Claims Processing',
      'Underwriting', 'Insurance Products', 'Insurance Operations',
      'Insurance Compliance', 'Insurance Strategy', 'Insurance Analysis',
      'Insurance Tools', 'Insurance Standards', 'Insurance Documentation',
      'Insurance Planning', 'Insurance Development', 'Insurance Services'
    ]
  },
  {
    name: 'Tax Management',
    skills: [
      'Tax Planning', 'Tax Compliance', 'Tax Research',
      'Tax Reporting', 'Tax Analysis', 'Tax Strategy',
      'Tax Operations', 'Tax Software', 'Tax Documentation',
      'Tax Regulations', 'Tax Preparation', 'Tax Advisory',
      'Tax Assessment', 'Tax Management', 'International Tax'
    ]
  },
  {
    name: 'Financial Technology',
    skills: [
      'Financial Software', 'Payment Systems', 'Digital Banking',
      'Blockchain Technology', 'Cryptocurrency', 'Financial Analytics',
      'Financial Automation', 'FinTech Solutions', 'Financial Integration',
      'Financial Security', 'Financial Innovation', 'Digital Payments',
      'Financial Platforms', 'Financial Apps', 'Financial Tools'
    ]
  },
  {
    name: 'Regulatory Compliance',
    skills: [
      'Financial Regulations', 'Compliance Management', 'Regulatory Reporting',
      'Compliance Monitoring', 'Compliance Documentation', 'Compliance Training',
      'Regulatory Analysis', 'Compliance Strategy', 'Compliance Tools',
      'Compliance Standards', 'Compliance Operations', 'Compliance Development',
      'Compliance Planning', 'Compliance Assessment', 'Compliance Implementation'
    ]
  },
  {
    name: 'Financial Reporting',
    skills: [
      'Financial Statements', 'Management Reports', 'Regulatory Reports',
      'Performance Reports', 'Budget Reports', 'Variance Reports',
      'Analysis Reports', 'Compliance Reports', 'Risk Reports',
      'Audit Reports', 'Tax Reports', 'Investment Reports',
      'Operations Reports', 'Strategic Reports', 'Financial Documentation'
    ]
  }
];

// Export flattened list for backward compatibility
export const FINANCIAL_SKILLS = FINANCIAL_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
